import { githubActionsApiRef } from './api/GithubActionsApi.esm.js';
import { GithubActionsClient } from './api/GithubActionsClient.esm.js';
import { rootRouteRef } from './routes.esm.js';
import { createPlugin, createApiFactory, configApiRef, createRoutableExtension, createComponentExtension } from '@backstage/core-plugin-api';
import { scmAuthApiRef } from '@backstage/integration-react';

const githubActionsPlugin = createPlugin({
  id: "github-actions",
  apis: [
    createApiFactory({
      api: githubActionsApiRef,
      deps: { configApi: configApiRef, scmAuthApi: scmAuthApiRef },
      factory: ({ configApi, scmAuthApi }) => new GithubActionsClient({ configApi, scmAuthApi })
    })
  ],
  routes: {
    entityContent: rootRouteRef
  }
});
const EntityGithubActionsContent = githubActionsPlugin.provide(
  createRoutableExtension({
    name: "EntityGithubActionsContent",
    component: () => import('./components/Router.esm.js').then((m) => m.Router),
    mountPoint: rootRouteRef
  })
);
const EntityLatestGithubActionRunCard = githubActionsPlugin.provide(
  createComponentExtension({
    name: "EntityLatestGithubActionRunCard",
    component: {
      lazy: () => import('./components/Cards/index.esm.js').then((m) => m.LatestWorkflowRunCard)
    }
  })
);
const EntityLatestGithubActionsForBranchCard = githubActionsPlugin.provide(
  createComponentExtension({
    name: "EntityLatestGithubActionsForBranchCard",
    component: {
      lazy: () => import('./components/Cards/index.esm.js').then(
        (m) => m.LatestWorkflowsForBranchCard
      )
    }
  })
);
const EntityRecentGithubActionsRunsCard = githubActionsPlugin.provide(
  createComponentExtension({
    name: "EntityRecentGithubActionsRunsCard",
    component: {
      lazy: () => import('./components/Cards/index.esm.js').then((m) => m.RecentWorkflowRunsCard)
    }
  })
);

export { EntityGithubActionsContent, EntityLatestGithubActionRunCard, EntityLatestGithubActionsForBranchCard, EntityRecentGithubActionsRunsCard, githubActionsPlugin };
//# sourceMappingURL=plugin.esm.js.map
